import React from 'react';
import styled from 'styled-components';

const LogoContainer = styled.div`
  height: 90px;
  margin-right: 12px;
  position: relative;
  margin-top: -6px;
`;

const LogoImage = styled.img`
  height: 100%;
  width: auto;
  object-fit: contain;
`;

const TransparentLogo = () => {
  return (
    <LogoContainer>
      <LogoImage src="/Cropped_Banner_transparent.png" alt="JNAR Logo" />
    </LogoContainer>
  );
};

export default TransparentLogo; 